export const css = /* css */ `
:host,
:host *,
*::before,
*::after {
  box-sizing: border-box;
}
a {
  color: inherit;
}
:not(.focus-visible),
:host(:not(.focus-visible)) {
  outline: none;
}
[hidden] {
  display: none !important;
}
:host {
  display: inline-block;
  --slicesui-button-background: transparent;
  --slicesui-button-color: #000;
  --slicesui-button-border-radius: var(--slicesui-tab-bar-border-radius, calc(var(--erem) * 1.25));
  width: 100%;
}
:host nav {
  display: flex;
  border-radius: var(--slicesui-button-border-radius, calc(var(--erem) * 1.25));
  position: relative;
  border: var(--slicesui-button-border-width, calc(var(--erem) / 16)) solid #000;
  white-space: nowrap;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}
:host nav::-webkit-scrollbar {
  width: 1px;
  display: none;
}
:host nav::-webkit-scrollbar-track {
  background: transparent;
}
:host nav::-webkit-scrollbar-thumb {
  background: transparent;
}
:host slicesui-button {
  border: 0;
  margin: var(--slicesui-tab-bar-button--margin, 0);
}
:host slicesui-button:first-child {
  margin-left: 0;
}
:host slicesui-button:last-child {
  margin-right: 0;
}
:host slicesui-button:hover {
  --slicesui-button-background: #e5e5e5;
}
:host slicesui-button[data-slices-selected] {
  --slicesui-button-background: var(--slicesui-button-background--active, #000);
  --slicesui-button-color: var(--slicesui-button-color--active, #fff);
  --slicesui-button-border-color: var(--slicesui-button-border-color--active, #fff);
}
:host([medium]) nav {
  border-width: 1px;
}
:host([small]) nav {
  border-width: 1px;
}
:host slicesui-selector {
  font-size: 0;
  display: block;
}
`;